import { isEmptyObject } from '@/common/converter/utils/is-empty-object'

/**
 * 이벤트 리스트에 있는 on-zzim, off-zzim 이벤트에 있는 bodyjson 을 구형 api 규격으로 변환
 * 신규 이벤트 규격의 경우 일괄적으로 bodylist 로 컨버팅 되나 zzim 에서 사용하는 규격인 bodyjson 으로 변경
 * 배열로 내려오는 body 의 값을 object 로 변경 후 반환 eg) ['key:value'] => { key: value }
 * @param eventList
 * @returns {undefined|unknown[]|undefined}
 */
export const convertEventBodyJson = (eventList = []) => {
  if (eventList.length < 1) {
    return undefined
  }

  return eventList?.map((eventItem) => {
    const { bodylist: bodyList, bodyjson, ...eventRest } = eventItem

    if (!isEmptyObject(bodyjson)) {
      return { bodyjson, ...eventRest }
    }

    const bodyJson = Object.fromEntries(
      bodyList?.map((body) => {
        const [key, value] = body?.split(':')
        return [key, value]
      }),
    )

    return {
      ...eventRest,
      bodyjson: bodyJson,
    }
  })
}
